import * as angular from "angular";
import { StaffImportStatus } from "../../models/staff-import-status.model";
import { LinkPathService } from "../../link-path/link-path.service";
import { FeatureFlagService } from "../../services/launch-darkly/feature-flag.service";
import { FeatureFlagNames } from "../../models/app-config.model";

interface TabsMenuItem {
    order: number;
    title: string;
    link: string;
}

const MATCH_SCHOOLS = 1;
const IMPORT_STUDENT_DATA = 2;
const IMPORT_STAFF_DATA = 3;

export class TabsMenuController {
    active: string;
    staffImportStatus: StaffImportStatus;
    isTooltipVisible: boolean = false;
    tooltipId: number;
    savedMatch: boolean;
    hasFullyImportedStudentsMostRecently:boolean;
    hasFullyImportedStaffMostRecently: boolean;
    private tabsMenuItems: TabsMenuItem[];
    isStudentImportEnabled;
    isStaffImportEnabled;

    studentImport = {
        order: 2,
        title: "Import Student Data",
        link: this.linkPathService.getStudentTabPath()
    };

    staffImport = {
        order: 3,
        title: "Import Staff Data",
        link: this.linkPathService.getStaffTabPath()
    };
    
    /* @ngInject */
    constructor(
        public $route: angular.route.IRouteService,
        private $location:angular.ILocationService,
        private $routeParams: { districtId: string },
        private linkPathService: LinkPathService,
        private featureFlagService: FeatureFlagService,
        private featureFlagNames: FeatureFlagNames
    ) {}

    $onInit() {
        this.tabsMenuItems = [
            {
                order: 1,
                title: "Match Schools",
                link: ""
            }
        ];

        this.featureFlagService().then((flags) => {
            let isStudentImportSystemEnabled = flags && flags.filter(
                (flag) => flag.name === this.featureFlagNames.STUDENT_SYSTEM_ENABLED
            )[0].value;
            if(isStudentImportSystemEnabled) {
                this.isStudentImportEnabled = !(flags && flags.filter(
                    (flag) => flag.name === this.featureFlagNames.STUDENT_TENANT_DISABLED
                )[0].value);
            } else {
                this.isStudentImportEnabled = flags && flags.filter(
                    (flag) => flag.name === this.featureFlagNames.STUDENT_TENANT_ENABLED
                )[0].value;
            }
            if(this.isStudentImportEnabled) {
                this.includeStudentImport();
            }
            this.isStaffImportEnabled = !(flags && flags.filter(
                (flag) => flag.name === this.featureFlagNames.STAFF_TENANT_DISABLED
            )[0].value);
            if (this.isStaffImportEnabled) {
                this.includeStaffImport();
            }
        },() => {
            this.includeStudentImport();
            this.includeStaffImport();
        });
    }

    includeStudentImport() {
        this.tabsMenuItems.splice(1, 0, this.studentImport)
    }

    includeStaffImport() {
        this.tabsMenuItems.splice(2, 0, this.staffImport)
    }

    getItems():TabsMenuItem[] {
        return this.tabsMenuItems;
    }

    isCurrentPageItem(item: TabsMenuItem): boolean {
        if (this.active) {
            return item.title === this.active;
        }

        let suffix = item.link ? `/${item.link}` : "";
        let itemPath = `/${this.$routeParams.districtId}${suffix}`;
        return this.$location.path() === itemPath;
    }

    linkToPage(item: TabsMenuItem) {
        if (item.order === MATCH_SCHOOLS || (this.isStudentOrStaffTab(item.order) && this.savedMatch)) {
            this.isTooltipVisible = false;
            this.tooltipId = 0;
            return this.$location.path(`/${this.$routeParams.districtId}/${item.link}`);
        }

        this.isTooltipVisible = true;
        this.tooltipId = item.order;
    }

    disablePageItem(item: TabsMenuItem): boolean {
        return this.isStudentOrStaffTab(item.order) && !this.savedMatch;
    }

    showTooltip(item: TabsMenuItem): boolean {
        return this.isTooltipVisible && this.tooltipId === item.order && !this.savedMatch;
    }

    isStudentOrStaffTab(order: number): boolean {
        return order === IMPORT_STUDENT_DATA || order === IMPORT_STAFF_DATA;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/tabs-menu/tabs-menu.controller.ts